import { DisasterTypes, FireLocations, Shifts } from "../types";

export const fireLocations = [
  FireLocations.Bedroom,
  FireLocations.Kitchen,
  FireLocations.Laundry,
  FireLocations.LivingRoom,
  FireLocations.Bathroom,
  FireLocations.MainEntrance,
];

export const disasterTypes = [
  DisasterTypes.Snow,
  DisasterTypes.Storm,
  DisasterTypes.Flood,
  DisasterTypes.Tornado,
  DisasterTypes.LockDown,
  DisasterTypes.Flood,
  DisasterTypes.Hurricane,
  DisasterTypes.Tornado,
  DisasterTypes.Storm,
  DisasterTypes.Hurricane,
  DisasterTypes.LockDown,
  DisasterTypes.Snow,
];

export const shifts = [Shifts.first, Shifts.second, Shifts.third];
